import React, { useEffect, useState } from 'react'
import Info from 'components/shared/Info';
import { ReactComponent as IconUser } from 'images/user.svg';
import Button from 'components/shared/Button';
import { Input } from 'components/shared/Input';
import ProgressDots from 'components/shared/ProgressDots';
import useUpdateUser from 'sdk/hooks/user/useUpdateUser';
import useUser from 'sdk/hooks/user/useUser';
import { StringConstant } from 'utils/Constants';
import styles from './SignUp.module.scss';

type NameViewProps = {
  stepsCount: number,
  curStep: number,
  handleNext: () => void,
  className?: string,
}

function NameView({
  stepsCount,
  curStep,
  handleNext,
  className,
}: NameViewProps) {
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [error, setError] = useState<string>('')

  const userData = useUser()

  const {
    mutate: updateUserMutation,
    isSuccess: isUpdateUserSuccess,
    isLoading: isUpdateUserLoading,
    error: updateUserError,
    isError: isUpdateUserError,
    reset: resetUpdateUser,
    data: updateUserData,
  } = useUpdateUser({
    id: userData?.data?.user?.id ?? '',
    first_name: firstName,
    last_name: lastName,
  })

  useEffect(() => {
    if (isUpdateUserSuccess) {
      handleNext()
      resetUpdateUser();
    }
  }, [isUpdateUserSuccess, updateUserData])

  useEffect(() => {
    if (isUpdateUserError) {
      setError(StringConstant.SIGN_UP_ERROR_MEESAGE)
    }
  }, [isUpdateUserError])

  const handleFirstNameChange = (e: React.FormEvent<HTMLInputElement>) => {
    setFirstName((e.target as HTMLInputElement).value)
  }

  const handleLastNameChange = (e: React.FormEvent<HTMLInputElement>) => {
    setLastName((e.target as HTMLInputElement).value)
  }

  return (
    <div className={className}>
      <div className={styles.subheader}>{StringConstant.SIGN_UP_YOUR_NAME}</div>

      <ProgressDots size={stepsCount} active={curStep} />

      <Input
        className={styles.phoneInput}
        value={firstName}
        onChange={handleFirstNameChange}
        placeholder={StringConstant.ENTER_FIRST_NAME}
        icon={<IconUser />}
        white
        wide
      />

      <Input
        className={styles.phoneInput}
        value={lastName}
        onChange={handleLastNameChange}
        placeholder={StringConstant.ENTER_LAST_NAME}
        icon={<IconUser />}
        white
        wide
      />

      <Info white>
        <span>
          {StringConstant.SIGN_UP_PROFILE_MESSAGE}
        </span>
      </Info>

      <Button
        className={styles.margin20}
        disabled={!(firstName && lastName) || isUpdateUserLoading}
        onClick={() => updateUserMutation()}
        loading={isUpdateUserLoading}
        black
        wide
      >
        Next
      </Button>
      {(error.length > 0) && (
        <div className={styles.errorMessage}>{error}</div>
      )}
    </div>
  )
}

export default NameView
